import React from 'react';

import { DownloadOutlined, FileUnknownOutlined } from '@ant-design/icons';

import { Button } from '@/shared/ui/Button';

import styles from '../FileViewer.module.css';

type UnsupportedFileViewerProps = {
  onDownload: () => void;
  fileName: string;
};

export const UnsupportedFileViewer: React.FC<UnsupportedFileViewerProps> = ({ onDownload, fileName }) => {
  return (
    <div className={styles.unsupportedContainer}>
      <FileUnknownOutlined style={{ fontSize: 48, color: '#ccc' }} />
      <div>
        미리보기를 지원하지 않는 파일 형식입니다: <strong>{fileName}</strong>
      </div>
      <Button prefix={<DownloadOutlined />} onClick={onDownload} variant="filled" color="standard">
        파일 다운로드
      </Button>
    </div>
  );
};
